import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ spacing }) =>
  createStyles({
    container: {
      height: '100%',
      paddingTop: spacing(3),
      paddingBottom: spacing(3),
    },

    actionBar: {
      width: '100%',
      marginBottom: spacing(8),
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '1.2rem',

      '& > h1': {
        fontWeight: 500,
        marginRight: spacing(8),
      },
      '& > .MuiFormControl-root': {
        flex: 1,
        minWidth: '20rem',
        margin: 0,
      },
      '& > a': {
        width: 'fit-content',
        margin: 0,
      },
    },
  }),
)
